import SearchParamsBase from '../../../../Elements/SearchParamsBase';

export default class ClientInvoiceLineItemSearchParams extends SearchParamsBase {
  static saveType = 'ClientInvoiceLineItemSearchParams';
  initialize() {
    this.ClientInvoiceId = '';
    this.Type = '';
  }

}
